export const brandName = "Morrisons More"